module.exports = __webpack_public_path__ + "img/fille.ef421582.png";